// Third party libraries
import _ from 'lodash';
import { Segment, Header, Input, Form, Label, Select } from 'semantic-ui-react';

// Constants
import { propsOptions } from '../../../../../../../../../utils/asanas';

// Locales
import I18n from '../../../../../../../../../i18n';

const RuleActionParams = ({ condition, index, onUpdate }) => {
    const { consequent } = condition;

    if (!consequent || !consequent.type) return null;

    const renderParams = () => {
        switch (consequent.type) {
            case 'adjust-time':
                return (
                    <>
                        <Header as='h5'>{I18n.t('personalizedSequence.rules.actionParams.adjustTime')}</Header>
                        <Form.Field>
                            <Label basic>{I18n.t('personalizedSequence.rules.actionParams.timeMultiplier')}</Label>
                            <Input
                                type="number"
                                step="0.1"
                                fluid
                                placeholder={I18n.t('personalizedSequence.rules.actionParams.timeMultiplierPlaceholder')}
                                value={consequent.data?.timeMultiplier || ''}
                                onChange={(e) => onUpdate(index, 'timeMultiplier', e.target.value)}
                            />
                        </Form.Field>
                    </>
                );

            case 'force-props':
                const requiresPropsSelectOptions = _.map(propsOptions, (text, value) => ({ key: value, text, value }));

                // Convertimos el string "block,strap" en un array ["block", "strap"] para el Select
                // Si está vacío, enviamos un array vacío para que no falle
                const currentValues = consequent.data?.requiredProps
                    ? consequent.data.requiredProps.split(',')
                    : [];

                return (
                    <>
                        <Header as='h5'>{I18n.t('personalizedSequence.rules.actionParams.forceProps')}</Header>
                        <Form.Field>
                            <Select
                                search
                                clearable
                                multiple
                                fluid // Añadido para mejor UI
                                selection // Necesario para que funcione el estilo de selección múltiple
                                name="requiredProps"
                                options={requiresPropsSelectOptions}
                                placeholder={I18n.t('practice.requiresProps')}
                                value={currentValues}
                                // Capturamos el segundo argumento { value } que provee Semantic UI
                                onChange={(e, { value }) => {
                                    // value es un array, ej: ["block", "strap"]
                                    // Lo unimos con comas para guardarlo como string
                                    const stringValue = value.join(',');
                                    onUpdate(index, 'requiredProps', stringValue);
                                }}
                            />
                        </Form.Field>
                    </>
                );

            default:
                return <p>{I18n.t('personalizedSequence.rules.actionParams.defaultAction')}</p>;
        }
    };

    return (
        <Segment color="blue" secondary style={{ marginTop: '0.5rem' }}>
            <Form>
                {renderParams()}
            </Form>
        </Segment>
    );
};

export default RuleActionParams;